const StopProduct = ({ index, customers, stopHandler }) => {
  const fun = x => {
    console.log("x", x);
  };
  console.log("customer ", customers[0]?.products__id);
  return (
    <div
      className="modal fade"
      id={`stopProductModal`}
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      style={{ backgroundColor: "rgba(1,1,1,0.5)" }}
    >
      <div className="modal-dialog">
        <div className="modal-content" style={{ minHeight: "100%" }}>
          <div className="modal-header" style={{ justifyContent: "end" }}>
            <h5 dir="ltr" className="modal-title" id="exampleModalLabel3">
              توقف محصول
            </h5>
            <button
              type="button"
              className="btn btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>

          <div className="modal-body modlatrashposition">
            <p>آیا محصول مد نظر متوقف شود؟</p>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary btn-sm"
              data-bs-dismiss="modal"
            >
              خیر
            </button>
            <button
              type="button"
              onClick={() => {
                stopHandler(index);
                console.log(
                  "stop",
                  customers,
                  index,
                  customers[index]?.products__id
                );
              }}
              className="btn btn-danger btn-sm"
              data-bs-dismiss="modal"
            >
              بله
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StopProduct;
